"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnMode = void 0;
exports.TurnMode = {
    Silence: "silence",
    Turn: "turn",
};
